<template>
    <v-dialog
        v-model="showDialog"
        width="500"
        scrollable
        :fullscreen="this.$vuetify.breakpoint.xsOnly"
    >
        <UploadOfflineResponsesCard
            v-if="activeDialog==='responses'"
            id="upload-offline-dialog"
            @upload-offline-images="uploadOfflineImages"
        />
        <UploadOfflineImagesCard
            v-else
            id="upload-offline-dialog"
            @close-dialog="close"
        />
    </v-dialog>
</template>
<script>
import serviceWorkerManager from '../../services/serviceWorkerManager';
import UploadOfflineResponsesCard from './UploadOfflineResponsesCard.vue';
import UploadOfflineImagesCard from './UploadOfflineImagesCard.vue';

export default {
    components: {
        UploadOfflineResponsesCard,
        UploadOfflineImagesCard,
    },
    data: () => ({
        activeDialog: 'responses',
    }),
    computed: {
        showDialog: {
            get() {
                return this.$store.getters.showUploadOfflineDialog;                
            },
            set(newValue) {
                this.$store.commit('SET_OFFLINE_RESPONSES_STATUSES', []);
                this.$store.commit('SET_SHOW_UPLOAD_OFFLINE_DIALOG', newValue);
            },
        },
    },
    methods: {
        uploadOfflineImages() {
            serviceWorkerManager.postAllOfflineImages();
            this.activeDialog = 'images';
        },
        close() {
            this.$store.commit('SET_SHOW_UPLOAD_OFFLINE_DIALOG', false);
        },

    },
};
</script>
<style>
#upload-offline-dialog .upload-progress-subtext {
    color: var(--ll-text-brand);
    font-weight: 500;
    line-height: 32px;
}
#upload-offline-dialog .upload-progress-subtext.successfull {
    font-size: 20px;
}
#upload-offline-dialog .table-label {
    font-size: 14px;
    color: var(--ll-text-primary);
    font-weight: 500;
}
#upload-offline-dialog .v-data-table {
    border: 1px solid var(--ll-border);
    width: 100%;
    overflow: hidden;
}
#upload-offline-dialog .v-data-table__wrapper {
    border-radius: 4px;
}
#upload-offline-dialog thead,
#upload-offline-dialog th {
    background-color: var(--ll-surface-subtle);
}

</style>
